import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

// API Base URL
const BASE_URL = "https://newalemny.3almny.app/api";

// Get student subjects
export const getStudentSubjects = createAsyncThunk(
  "subjects/getStudentSubjects",
  async (_, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token3almny");
      const headers = {
        "Content-Type": "application/json",
      };

      // إضافة التوكن إذا كان موجود
      if (token) {
        headers.Authorization = `Bearer ${token}`;
      }
      const response = await fetch(`${BASE_URL}/subjects/student_subjects`, {
        headers: headers,
      });
      const data = await response.json();

      if (!response.ok) {
        return rejectWithValue(data.message || "حدث خطأ في جلب المواد الدراسية");
      }

      return data.result;
    } catch (error) {
      return rejectWithValue("حدث خطأ في الاتصال بالخادم");
    }
  }
);

// Get teacher subjects
export const getTeacherSubjects = createAsyncThunk(
  "subjects/getTeacherSubjects",
  async (_, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token3almny");
      if (!token) {
        return rejectWithValue("التوكن مطلوب للمعلمين");
      }

      const headers = {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
      };

      const response = await fetch(`${BASE_URL}/teacher/teacher_subjects`, {
        headers: headers,
      });
      const data = await response.json();

      if (!response.ok) {
        return rejectWithValue(data.message || "حدث خطأ في جلب مواد المعلم");
      }

      return data.result;
    } catch (error) {
      return rejectWithValue("حدث خطأ في الاتصال بالخادم");
    }
  }
);

const initialState = {
  studentSubjects: [],
  teacherSubjects: [],
  subjectsLoading: false,
  subjectsError: null,
};

const subjectsSlice = createSlice({
  name: "subjects",
  initialState,
  reducers: {
    clearSubjectsError: (state) => {
      state.subjectsError = null;
    },
    resetSubjects: (state) => {
      state.studentSubjects = [];
      state.teacherSubjects = [];
      state.subjectsLoading = false;
      state.subjectsError = null;
    },
  },
  extraReducers: (builder) => {
    // Get Student Subjects
    builder
      .addCase(getStudentSubjects.pending, (state) => {
        state.subjectsLoading = true;
        state.subjectsError = null;
      })
      .addCase(getStudentSubjects.fulfilled, (state, action) => {
        state.subjectsLoading = false;
        state.studentSubjects = action.payload;
      })
      .addCase(getStudentSubjects.rejected, (state, action) => {
        state.subjectsLoading = false;
        state.subjectsError = action.payload;
      });

    // Get Teacher Subjects
    builder
      .addCase(getTeacherSubjects.pending, (state) => {
        state.subjectsLoading = true;
        state.subjectsError = null;
      })
      .addCase(getTeacherSubjects.fulfilled, (state, action) => {
        state.subjectsLoading = false;
        state.teacherSubjects = action.payload;
      })
      .addCase(getTeacherSubjects.rejected, (state, action) => {
        state.subjectsLoading = false;
        state.subjectsError = action.payload;
      });
  },
});

export const { clearSubjectsError, resetSubjects } = subjectsSlice.actions;
export default subjectsSlice.reducer; 